export default __webpack_public_path__ + "media/images/mailer/logo-3af07665644e4d0d3f7f383bd5faddfb.png";